__turbopack_context__.v({
  "charCount": "BioInput-module-scss-module__yEgEiq__charCount",
  "editor": "BioInput-module-scss-module__yEgEiq__editor",
  "editorError": "BioInput-module-scss-module__yEgEiq__editorError",
  "errorMessage": "BioInput-module-scss-module__yEgEiq__errorMessage",
  "genButton": "BioInput-module-scss-module__yEgEiq__genButton",
  "header": "BioInput-module-scss-module__yEgEiq__header",
  "label": "BioInput-module-scss-module__yEgEiq__label",
  "loader": "BioInput-module-scss-module__yEgEiq__loader",
  "loading": "BioInput-module-scss-module__yEgEiq__loading",
  "prixClipFix": "BioInput-module-scss-module__yEgEiq__prixClipFix",
  "pulse": "BioInput-module-scss-module__yEgEiq__pulse",
  "root": "BioInput-module-scss-module__yEgEiq__root",
  "rotate": "BioInput-module-scss-module__yEgEiq__rotate",
});
